export class GenerateDevis {
  template_id: any;
  data: any;
}
